import CreateReservations from '../../Components/Reservations/createReservations'
export default function CreateReservation() {
    return (
  <CreateReservations/>
    )
}